export const RANGES = ['now', 'short_term', 'medium_term', 'long_term'] as const
export type RotationRange = (typeof RANGES)[number]
export const RANGE_LABELS: Record<RotationRange, string> = {
  now: 'Now',
  short_term: '4 weeks',
  medium_term: '6 months',
  long_term: 'Last year',
}
export interface SpotifyAlbum {
  id: string
  name: string
  album_type: string
  total_tracks: number
  release_date: string
  artists: { id?: string; name: string }[]
  images: { url: string; width: number | null }[]
}
export interface SpotifyTrack {
  id: string
  name: string
  duration_ms: number
  track_number: number
  disc_number: number
  album: SpotifyAlbum
  artists?: { id?: string; name: string }[]
  explicit?: boolean
  is_local?: boolean
  linked_from?: { id: string }
}
export interface RecentPlay {
  track: SpotifyTrack
  played_at: string
}
export interface RotationAlbum {
  key: string
  sourceAlbumIds: string[]
  id: string
  title: string
  artist: string
  year: string
  coverUrl: string
  spotifyUrl: string
  rank: number
  score: number
  topTrack: string
  recentPlays: number | null
  recentTrackMinutes: number | null
  firstRecentPlay: string | null
  lastRecentPlay: string | null
  isPlaying: boolean
}
export interface RangeData {
  albums: RotationAlbum[]
  updatedAt: string
  error?: string
}
export type RotationData = Record<RotationRange, RangeData>
export interface AlbumTrack {
  id: string
  name: string
  duration_ms: number
  track_number: number
  disc_number: number
}
export interface AlbumPalette {
  dark: boolean
  paper: string
  ink: string
}
export interface AlbumDetails {
  palette?: AlbumPalette
  tracks: AlbumTrack[]
  totalMinutes: number
  label: string
}
